import Swiper, { Autoplay, Pagination } from 'swiper';

export default function() {
    const swiper = new Swiper('.testimonial__carousel', {
        loop: true,
        modules: [Autoplay, Pagination],
        autoplay: {
            delay: 7500,
            pauseOnMouseEnter: true
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        }
      });
}